module.exports = __webpack_public_path__ + "static/media/medallion.d8dab3b1.png";